export default __webpack_public_path__ + "static/media/pyramid-02.756cc3cb.svg";